/**
 * Hush Puppies - Webkul Product Auction Custom Script
 * Handles event delegation, Buy Now checkout redirection, portal navigation, and UI enhancements.
 */
(function () {
  'use strict';

  function initAuctionPortalEnhancements() {
    // 1. Inject navigation bar on Webkul App Proxy Portal (#paTabs)
    var paTabs = document.getElementById('paTabs');
    if (paTabs && !document.querySelector('.hp-auction-portal-nav')) {
      var navDiv = document.createElement('div');
      navDiv.className = 'hp-auction-portal-nav';
      navDiv.innerHTML = `
        <!-- Desktop Navigation Pills (Hidden on Mobile) -->
        <div class="hp-desktop-nav-pills">
          <a class="hp-account-pill-btn" href="/account">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
            Back to My Account
          </a>
          <a class="hp-account-pill-btn" href="/collections/all">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
            Browse Store
          </a>
          <a class="hp-account-pill-btn hp-account-pill-btn--primary" href="/account">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            My Account
          </a>
        </div>

        <!-- Mobile Drawer Trigger Button & Bottom Sheet (Visible on Mobile) -->
        <div class="hp-mobile-nav-wrapper">
          <button type="button" class="hp-mobile-nav-trigger" id="hpMobileNavTrigger" aria-label="Open Navigation Menu" aria-expanded="false">
            <span class="hp-mobile-nav-trigger__left">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
              <span>Auction Menu: <strong>Bidding Details</strong></span>
            </span>
            <svg class="hp-mobile-nav-trigger__arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </button>

          <div class="hp-mobile-nav-modal" id="hpMobileNavModal">
            <div class="hp-mobile-nav-modal__backdrop" id="hpMobileNavBackdrop"></div>
            <div class="hp-mobile-nav-modal__sheet">
              <div class="hp-mobile-nav-modal__header">
                <div class="hp-mobile-nav-modal__title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  <span>Auction Navigation</span>
                </div>
                <button type="button" class="hp-mobile-nav-modal__close" id="hpMobileNavClose" aria-label="Close menu">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>

              <div class="hp-mobile-nav-modal__body">
                <a class="hp-mobile-menu-item active" href="/tools/products-on-auction">
                  <div class="hp-mobile-menu-item__icon hp-mobile-menu-item__icon--auction">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  </div>
                  <div class="hp-mobile-menu-item__text">
                    <span class="hp-mobile-menu-item__title">Bidding Details</span>
                    <span class="hp-mobile-menu-item__sub">Active bids, winning items & status</span>
                  </div>
                  <svg class="hp-mobile-menu-item__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                </a>

                <a class="hp-mobile-menu-item" href="/account">
                  <div class="hp-mobile-menu-item__icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  </div>
                  <div class="hp-mobile-menu-item__text">
                    <span class="hp-mobile-menu-item__title">My Account & Orders</span>
                    <span class="hp-mobile-menu-item__sub">View order history and account details</span>
                  </div>
                  <svg class="hp-mobile-menu-item__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                </a>

                <a class="hp-mobile-menu-item" href="/collections/all">
                  <div class="hp-mobile-menu-item__icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                  </div>
                  <div class="hp-mobile-menu-item__text">
                    <span class="hp-mobile-menu-item__title">Browse Store</span>
                    <span class="hp-mobile-menu-item__sub">Explore all Hush Puppies products</span>
                  </div>
                  <svg class="hp-mobile-menu-item__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      `;
      if (paTabs.parentNode) {
        paTabs.parentNode.insertBefore(navDiv, paTabs);
      } else {
        paTabs.insertBefore(navDiv, paTabs.firstChild);
      }
    }

    // 2. Delegated listener for "Buy Now" on Winning Bids
    document.addEventListener('click', function (e) {
      var target = e.target.closest(
        '.wk_pay_btn, .wk-buy-now, .auction_buy_btn, .wk_btn_success, [data-action="buy"]'
      );
      if (!target) return;

      target.style.opacity = '0.7';
      target.style.pointerEvents = 'none';

      var href = target.getAttribute('href') || target.dataset.href;
      if (href && href !== '#' && href !== 'javascript:void(0)') {
        window.location.href = href;
        return;
      }

      setTimeout(function () {
        target.style.opacity = '1';
        target.style.pointerEvents = 'auto';
      }, 4000);
    });

    // 3. Hide loader safely using MutationObserver & interval fallback
    var loaders = document.querySelectorAll('.pa-loader');
    if (loaders.length > 0) {
      var hideLoaders = function () {
        loaders.forEach(function (l) {
          l.style.opacity = '0';
          l.style.transition = 'opacity 0.3s ease';
          setTimeout(function () { l.style.display = 'none'; }, 300);
        });
      };

      var targets = document.querySelectorAll('#wk_bidding_details, #products_on_auction, #paTabs');
      if (targets.length > 0 && window.MutationObserver) {
        var observer = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].target.childNodes.length > 0) {
              hideLoaders();
              observer.disconnect();
              break;
            }
          }
        });

        targets.forEach(function (t) {
          observer.observe(t, { childList: true, subtree: true });
        });
      }

      var checkTableInterval = setInterval(function () {
        var container = document.querySelector('#wk_bidding_details, #products_on_auction, #paTabs');
        if (container && container.innerHTML.trim().length > 0) {
          hideLoaders();
          clearInterval(checkTableInterval);
        }
      }, 250);

      setTimeout(function () {
        hideLoaders();
        clearInterval(checkTableInterval);
      }, 4000);
    }

    // 4. Hide Standard Add-to-Cart & Sticky ATC for Auction PDP
    function hideAuctionStandardAtc() {
      var isAuction = document.querySelector(
        '[data-is-auction="true"], #wk_auction_details, .wk_auction_details, .wk_auction_wrapper, #auction_box, [data-auction-id]'
      );
      if (isAuction) {
        var targets = document.querySelectorAll(
          'product-form, .product-info__add-to-cart, .product-info__block--buy-buttons, sticky-atc-panel, .sticky-atc-panel'
        );
        targets.forEach(function (el) {
          if (!el.closest('.wk_auction_wrapper, #wk_auction_details, .wk_auction_details')) {
            el.style.setProperty('display', 'none', 'important');
          }
        });
      }
    }

    // 5. Enhance PDP Auction Input (Currency Prefix & Thousand Separator Formatting)
    function enhanceAuctionInput() {
      var bidInput = document.getElementById('bid_amount');
      if (!bidInput) return;

      // Wrap in currency prefix group if not already wrapped
      if (!bidInput.closest('.hp-bid-input-wrap') && bidInput.parentNode) {
        var wrap = document.createElement('div');
        wrap.className = 'hp-bid-input-wrap';
        var badge = document.createElement('span');
        badge.className = 'hp-bid-currency-badge';
        badge.textContent = 'IDR';
        
        bidInput.parentNode.insertBefore(wrap, bidInput);
        wrap.appendChild(badge);
        wrap.appendChild(bidInput);
      }

      bidInput.placeholder = '0';
      bidInput.setAttribute('inputmode', 'numeric');
      bidInput.setAttribute('autocomplete', 'off');

      function formatNumber(val) {
        var num = String(val).replace(/\D/g, '');
        if (!num) return '';
        return new Intl.NumberFormat('id-ID').format(num);
      }

      if (bidInput.dataset.formattedListener !== 'true') {
        bidInput.dataset.formattedListener = 'true';

        bidInput.addEventListener('input', function () {
          var raw = bidInput.value.replace(/\D/g, '');
          bidInput.value = formatNumber(raw);
          
          var hiddenInput = document.getElementById('bid_amount_hidden');
          if (hiddenInput) {
            hiddenInput.value = raw;
          }
        });
      }

      // When Place Bid is clicked, briefly unformat to raw number so Webkul validation succeeds
      var submitBtn = document.querySelector('.wk_submit_bid, button.wk_submit_bid');
      if (submitBtn && submitBtn.dataset.listener !== 'true') {
        submitBtn.dataset.listener = 'true';
        submitBtn.addEventListener('click', function () {
          var raw = bidInput.value.replace(/\D/g, '');
          if (raw) {
            bidInput.value = raw;
            setTimeout(function () {
              bidInput.value = formatNumber(raw);
            }, 300);
          }
        }, true);
      }

      // Toggle checkbox when clicking the entire row and clean up DOM
      var privateRow = document.querySelector('.pa-form-bg .noselect');
      if (privateRow) {
        var oldFakeLabel = privateRow.querySelector('label[for="is_private"]');
        if (oldFakeLabel) {
          oldFakeLabel.remove();
        }

        if (privateRow.dataset.listener !== 'true') {
          privateRow.dataset.listener = 'true';
          privateRow.addEventListener('click', function (e) {
            var chk = document.getElementById('is_private');
            if (chk && e.target !== chk) {
              chk.checked = !chk.checked;
              var evt = new Event('change', { bubbles: true });
              chk.dispatchEvent(evt);
            }
          });
        }
      }
    }

    // 6. Mobile Account Navigation Drawer
    function initMobileAccountDrawer() {
      var trigger = document.getElementById('hpMobileNavTrigger');
      var modal = document.getElementById('hpMobileNavModal');
      var closeBtn = document.getElementById('hpMobileNavClose');
      var backdrop = document.getElementById('hpMobileNavBackdrop');

      if (!trigger || !modal || trigger.dataset.initialized === 'true') return;
      trigger.dataset.initialized = 'true';

      function openDrawer() {
        modal.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }

      function closeDrawer() {
        modal.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (modal.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closeDrawer();
        });
      }

      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeDrawer();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeDrawer();
        }
      });
    }

    // 7. Inject "Details" Button & Popup Modal for Auction Rows
    function initAuctionRowDetails() {
      var modal = document.getElementById('hpAuctionDetailModal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'hpAuctionDetailModal';
        modal.className = 'hp-auction-detail-modal';
        modal.innerHTML = `
          <div class="hp-auction-detail-modal__backdrop" id="hpAuctionDetailBackdrop"></div>
          <div class="hp-auction-detail-modal__sheet">
            <div class="hp-auction-detail-modal__header">
              <div class="hp-auction-detail-modal__title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
                <span>Bidding Information</span>
              </div>
              <button type="button" class="hp-auction-detail-modal__close" id="hpAuctionDetailClose" aria-label="Close">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div class="hp-auction-detail-modal__body" id="hpAuctionDetailBody"></div>
          </div>
        `;
        document.body.appendChild(modal);

        var closeBtn = document.getElementById('hpAuctionDetailClose');
        var backdrop = document.getElementById('hpAuctionDetailBackdrop');

        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          });
        }
        if (backdrop) {
          backdrop.addEventListener('click', function () {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          });
        }
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
          }
        });
      }

      var rows = document.querySelectorAll('table.pa-table tbody tr, #paTabs table tbody tr, #wk_bidding_details table tbody tr');
      rows.forEach(function (tr) {
        var rowText = tr.textContent.toLowerCase();
        if (
          rowText.includes('no record') ||
          rowText.includes('no records') ||
          rowText.includes('no data') ||
          rowText.includes('no auction') ||
          rowText.includes('no bidding') ||
          tr.querySelector('td[colspan]') ||
          tr.classList.contains('no-records') ||
          tr.querySelector('.td_pagination') ||
          tr.querySelectorAll('td').length <= 2
        ) {
          var accidentalBtn = tr.querySelector('.hp-detail-btn');
          if (accidentalBtn) accidentalBtn.remove();
          return;
        }

        var actionTd = tr.querySelector('.td_action');
        if (!actionTd) {
          if (tr.querySelector('.td_product_name, .td_product_image, a[href*="/products/"]')) {
            actionTd = tr.querySelector('td:last-child');
          }
        }
        if (!actionTd || actionTd.querySelector('.hp-detail-btn')) return;
        if (actionTd.classList.contains('td_pagination')) return;

        var detailBtn = document.createElement('button');
        detailBtn.type = 'button';
        detailBtn.className = 'hp-detail-btn';
        detailBtn.innerHTML = `Details`;
        detailBtn.title = 'View Full Bidding Details';

        detailBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var imgEl = tr.querySelector('.td_product_image img, td img');
          var imgSrc = imgEl ? imgEl.src : '';
          var titleEl = tr.querySelector('.td_product_name a, td:nth-child(2) a, .td_product_name');
          var titleText = titleEl ? titleEl.textContent.trim() : 'Auction Product';
          var productUrl = titleEl && titleEl.href ? titleEl.href : '#';

          var currentBidEl = tr.querySelector('.td_current_bid, td:nth-child(3)');
          var currentBid = currentBidEl ? currentBidEl.textContent.trim() : '-';

          var highestBidEls = tr.querySelectorAll('.td_current_bid');
          var highestBid = (highestBidEls.length > 1 ? highestBidEls[1].textContent.trim() : '') || 
                           (tr.querySelector('.td_highest_bid') ? tr.querySelector('.td_highest_bid').textContent.trim() : '-');

          var maxBidEl = tr.querySelector('.td_max_bid');
          var maxBid = maxBidEl ? maxBidEl.textContent.trim() : 'NA';

          var endDateEl = tr.querySelector('.td_end_date');
          var endDate = endDateEl ? endDateEl.textContent.trim() : '-';

          var noOfBidsEl = tr.querySelector('.td_no_of_bids');
          var noOfBids = noOfBidsEl ? noOfBidsEl.textContent.trim() : '-';

          var bidderEl = tr.querySelector('.td_highest_bidder');
          var bidderName = bidderEl ? bidderEl.textContent.trim() : '-';

          var actionBtn = actionTd.querySelector('a, button');
          var actionUrl = actionBtn ? (actionBtn.getAttribute('href') || (actionBtn.closest('a') ? actionBtn.closest('a').href : productUrl)) : productUrl;

          var body = document.getElementById('hpAuctionDetailBody');
          body.innerHTML = `
            <div class="hp-modal-prod-summary">
              ${imgSrc ? `<img src="${imgSrc}" alt="${titleText}" class="hp-modal-prod-img" />` : ''}
              <div>
                <a href="${productUrl}" class="hp-modal-prod-title" target="_blank">${titleText}</a>
                <span class="hp-status-badge hp-status-badge--shipping" style="margin-top: 4px;">Live Auction</span>
              </div>
            </div>

            <div class="hp-modal-grid">
              <div class="hp-modal-stat-card">
                <span class="hp-modal-stat-label">Your Current Bid</span>
                <span class="hp-modal-stat-value text-emerald">${currentBid}</span>
              </div>
              <div class="hp-modal-stat-card">
                <span class="hp-modal-stat-label">Highest Bid</span>
                <span class="hp-modal-stat-value">${highestBid}</span>
              </div>
              <div class="hp-modal-stat-card">
                <span class="hp-modal-stat-label">Your Max Bid</span>
                <span class="hp-modal-stat-value">${maxBid}</span>
              </div>
              <div class="hp-modal-stat-card">
                <span class="hp-modal-stat-label">Total Bids</span>
                <span class="hp-modal-stat-value">${noOfBids} bids</span>
              </div>
              <div class="hp-modal-stat-card">
                <span class="hp-modal-stat-label">Highest Bidder</span>
                <span class="hp-modal-stat-value">${bidderName}</span>
              </div>
              <div class="hp-modal-stat-card">
                <span class="hp-modal-stat-label">Auction End Date</span>
                <span class="hp-modal-stat-value">${endDate}</span>
              </div>
            </div>

            <div class="hp-modal-footer-cta">
              <a href="${actionUrl}" target="_blank" class="hp-account-pill-btn hp-account-pill-btn--primary" style="width: 100%; text-align: center; justify-content: center; padding: 11px;">
                View Product Auction Page
              </a>
            </div>
          `;

          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        });

        actionTd.insertBefore(detailBtn, actionTd.firstChild);
      });
    }

    // 8. Manage "Buy All" Button State (Enabled only when >= 1 checkbox checked)
    function initBuyAllState() {
      var buyAllBtns = document.querySelectorAll(
        '#wk_buy_all, #buy_all_btn, .wk_buy_all, button[id*="buy_all"], .btn-buy-all'
      );
      if (!buyAllBtns.length) return;

      var updateBuyAllButtons = function () {
        var rowCheckboxes = document.querySelectorAll(
          '#paTabs table tbody input[type="checkbox"], #wk_bidding_details table tbody input[type="checkbox"], .pa-table tbody input[type="checkbox"], .hp-mobile-item-chk'
        );

        var checkedCount = 0;
        rowCheckboxes.forEach(function (chk) {
          if (chk.checked) checkedCount++;
        });

        buyAllBtns.forEach(function (btn) {
          if (checkedCount === 0) {
            btn.disabled = true;
            btn.classList.add('disabled');
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.disabled = false;
            btn.classList.remove('disabled');
            btn.removeAttribute('aria-disabled');
          }
        });
      };

      updateBuyAllButtons();

      if (document.body.dataset.buyAllListener !== 'true') {
        document.body.dataset.buyAllListener = 'true';
        document.addEventListener('change', function (e) {
          if (e.target && e.target.type === 'checkbox') {
            setTimeout(updateBuyAllButtons, 30);
          }
        });

        document.addEventListener('click', function (e) {
          var btn = e.target.closest('#wk_buy_all, #buy_all_btn, .wk_buy_all, button[id*="buy_all"], .btn-buy-all');
          if (btn && (btn.disabled || btn.classList.contains('disabled'))) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }
    }

    // 9. Mobile Tab Dropdown Selector (Clear, noticeable & touch-friendly dropdown for mobile)
    function initMobileTabDropdown() {
      var navTabs = document.querySelector('#paTabs ul.nav-tabs, .pa-tabs ul, .nav.nav-tabs');
      if (!navTabs || document.querySelector('.hp-mobile-tab-dropdown-wrap')) return;

      var tabLis = navTabs.querySelectorAll('li');
      if (!tabLis.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'hp-mobile-tab-dropdown-wrap';

      var label = document.createElement('label');
      label.className = 'hp-mobile-tab-label';
      label.textContent = 'Auction Category';

      var selectContainer = document.createElement('div');
      selectContainer.className = 'hp-mobile-tab-select-container';

      var select = document.createElement('select');
      select.className = 'hp-mobile-tab-select';
      select.setAttribute('aria-label', 'Select Auction Category');

      tabLis.forEach(function (li) {
        var a = li.querySelector('a');
        if (!a) return;
        var opt = document.createElement('option');
        var href = a.getAttribute('href') || window.location.href;
        opt.value = href;
        opt.textContent = a.textContent.trim();
        if (li.classList.contains('active') || a.classList.contains('active')) {
          opt.selected = true;
        }
        select.appendChild(opt);
      });

      select.addEventListener('change', function () {
        if (select.value && select.value !== '#' && select.value !== window.location.href) {
          window.location.href = select.value;
        }
      });

      selectContainer.appendChild(select);
      wrap.appendChild(label);
      wrap.appendChild(selectContainer);

      navTabs.parentNode.insertBefore(wrap, navTabs);
    }

    // 10. Sync Mobile Card Checkboxes with Webkul Table
    function syncMobileCardCheckboxes() {
      var desktopRows = document.querySelectorAll(
        'table.pa-table tbody tr.wk-hidden-698, #paTabs table tbody tr.wk-hidden-698, #paTabs tbody tr:not(.wk-visible-698)'
      );
      var mobileCards = document.querySelectorAll(
        '#paTabs section.card-border, #paTabs section.bg-surface-container-lowest, #paTabs tr.wk-visible-698 section, .table-responsive > section'
      );

      if (mobileCards.length > 0 && desktopRows.length > 0) {
        mobileCards.forEach(function (card, idx) {
          var desktopTr = desktopRows[idx];
          var desktopChk = desktopTr ? desktopTr.querySelector('input[type="checkbox"]') : null;

          if (desktopChk && !card.querySelector('.hp-card-chk-wrap')) {
            var chkWrap = document.createElement('div');
            chkWrap.className = 'hp-card-chk-wrap';
            chkWrap.innerHTML = `
              <label class="hp-card-chk-label">
                <input type="checkbox" class="hp-mobile-item-chk" ${desktopChk.checked ? 'checked' : ''} />
                <span class="hp-card-chk-text">Select This Item</span>
              </label>
            `;

            var mobChk = chkWrap.querySelector('input[type="checkbox"]');
            mobChk.addEventListener('change', function () {
              desktopChk.checked = mobChk.checked;
              var evt = new Event('change', { bubbles: true });
              desktopChk.dispatchEvent(evt);
            });

            desktopChk.addEventListener('change', function () {
              mobChk.checked = desktopChk.checked;
            });

            card.insertBefore(chkWrap, card.firstChild);
          }
        });
      }

      // Sync Mobile "Select All" (#wk_select_All_small) with Desktop "Select All" (#wk_select_All)
      var mobSelectAll = document.getElementById('wk_select_All_small');
      var deskSelectAll = document.getElementById('wk_select_All');

      if (mobSelectAll && mobSelectAll.dataset.syncListener !== 'true') {
        mobSelectAll.dataset.syncListener = 'true';
        mobSelectAll.addEventListener('change', function () {
          var isChecked = mobSelectAll.checked;
          if (deskSelectAll) {
            deskSelectAll.checked = isChecked;
          }
          var allDeskChks = document.querySelectorAll('.desktop-checkbox, .wk_select_checkbox, table.pa-table tbody input[type="checkbox"]');
          allDeskChks.forEach(function (chk) {
            chk.checked = isChecked;
            var evt = new Event('change', { bubbles: true });
            chk.dispatchEvent(evt);
          });
          var allMobChks = document.querySelectorAll('.hp-mobile-item-chk');
          allMobChks.forEach(function (chk) {
            chk.checked = isChecked;
          });
        });
      }

      if (deskSelectAll && deskSelectAll.dataset.syncListener !== 'true') {
        deskSelectAll.dataset.syncListener = 'true';
        deskSelectAll.addEventListener('change', function () {
          var isChecked = deskSelectAll.checked;
          if (mobSelectAll) {
            mobSelectAll.checked = isChecked;
          }
          var allMobChks = document.querySelectorAll('.hp-mobile-item-chk');
          allMobChks.forEach(function (chk) {
            chk.checked = isChecked;
          });
        });
      }
    }

    hideAuctionStandardAtc();
    enhanceAuctionInput();
    initMobileAccountDrawer();
    initAuctionRowDetails();
    initBuyAllState();
    initMobileTabDropdown();
    syncMobileCardCheckboxes();

    if (window.MutationObserver) {
      var atcObserver = new MutationObserver(function () {
        hideAuctionStandardAtc();
        enhanceAuctionInput();
        initMobileAccountDrawer();
        initAuctionRowDetails();
        initBuyAllState();
        initMobileTabDropdown();
        syncMobileCardCheckboxes();
      });
      atcObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  /**
   * ============================================================================
   * 11. Auction Collection Page Live Integration (/collections/auction)
   * Fetches real Webkul auction data for each product card, updates live prices,
   * starting bids, bid counts, countdown timers, and handles Place My Bid popup
   * modal with bid submission and ended auction states.
   * ============================================================================
   */
  function initAuctionCollectionPage() {
    var auctionPage = document.getElementById('hp-auction-page');
    if (!auctionPage || auctionPage.dataset.initialized === 'true') return;
    auctionPage.dataset.initialized = 'true';

    var customerId = auctionPage.dataset.customerId || '';
    var shopName = auctionPage.dataset.shopName || 'hushpuppies-id.myshopify.com';
    var isLoggedIn = auctionPage.dataset.loggedIn === 'true';
    var termsUrl = auctionPage.dataset.termsUrl || '/pages/auction-terms';

    var activeCard = null;

    // Number formatting helper (IDR)
    function cleanDigits(val) {
      if (!val && val !== 0) return '0';
      var str = String(val).trim();
      if (str.indexOf('.') !== -1 && str.indexOf(',') !== -1) {
        str = str.split('.')[0];
      } else if (/\.\d{2}$/.test(str)) {
        str = str.replace(/\.\d{2}$/, '');
      }
      return str.replace(/[^\d]/g, '') || '0';
    }

    function formatRupiah(amount) {
      if (!amount && amount !== 0) return 'Rp0';
      var digits = cleanDigits(amount);
      var num = parseFloat(digits);
      if (isNaN(num)) return 'Rp0';
      return 'Rp' + new Intl.NumberFormat('id-ID').format(Math.round(num));
    }

    function formatNumberDigits(val) {
      var d = cleanDigits(val);
      if (!d || d === '0') return '';
      return new Intl.NumberFormat('id-ID').format(d);
    }

    function maskPriceDynamic(priceVal, formattedPrice) {
      if (formattedPrice && /\d/.test(formattedPrice)) {
        return formattedPrice.replace(/\d/g, 'x');
      }
      if (!priceVal) return 'Rp xxx.xxx';
      var num = parseInt(cleanDigits(priceVal), 10);
      if (isNaN(num) || num <= 0) return 'Rp xxx.xxx';
      var rawStr = String(num);
      if (rawStr.length >= 5 && rawStr.slice(-2) === '00') {
        num = Math.floor(num / 100);
      }
      var formatted = new Intl.NumberFormat('id-ID').format(num);
      return 'Rp ' + formatted.replace(/\d/g, 'x');
    }

    function parseDateToMs(raw) {
      if (!raw) return 0;
      var str = String(raw).trim();
      if (!str) return 0;
      var num = parseInt(str, 10);
      if (/^\d{10}$/.test(str)) return num * 1000;
      if (/^\d{13}$/.test(str)) return num;

      // Match YYYY-MM-DD HH:mm:ss or YYYY-MM-DD HH:mm
      if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
        var isoStr = str.replace(' ', 'T');
        if (!/(Z|[+-]\d{2}(:?\d{2})?)$/.test(isoStr)) {
          isoStr += '+07:00'; // Default GMT+7 (Western Indonesia Time)
        }
        var parsed = Date.parse(isoStr);
        if (!isNaN(parsed) && parsed > 0) return parsed;
      }

      var fallbackParsed = Date.parse(str);
      return (!isNaN(fallbackParsed) && fallbackParsed > 0) ? fallbackParsed : 0;
    }

    // Sequential JSONP Queue to prevent callback collisions
    var jsonpQueue = [];
    var isProcessingJsonp = false;

    function queueJsonp(url, callbackName, done) {
      jsonpQueue.push({ url: url, callbackName: callbackName, done: done });
      processJsonpQueue();
    }

    function processJsonpQueue() {
      if (isProcessingJsonp || jsonpQueue.length === 0) return;
      isProcessingJsonp = true;
      var item = jsonpQueue.shift();

      var script = document.createElement('script');
      var timeoutId;

      window[item.callbackName] = function (data) {
        clearTimeout(timeoutId);
        cleanup();
        try {
          item.done(null, data);
        } catch (err) {
          console.error('[Webkul Auction] Callback error:', err);
        }
        isProcessingJsonp = false;
        processJsonpQueue();
      };

      function cleanup() {
        delete window[item.callbackName];
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      timeoutId = setTimeout(function () {
        cleanup();
        item.done(new Error('JSONP timeout for ' + item.url));
        isProcessingJsonp = false;
        processJsonpQueue();
      }, 12000);

      script.src = item.url;
      script.onerror = function () {
        clearTimeout(timeoutId);
        cleanup();
        item.done(new Error('JSONP network error'));
        isProcessingJsonp = false;
        processJsonpQueue();
      };

      document.head.appendChild(script);
    }

    // Modal elements
    var bidModal = document.getElementById('hpAuctionBidModal');
    var historyModal = document.getElementById('hpAuctionHistoryModal');

    var bidInput = document.getElementById('hpBidModalAmountInput');
    var bidSubmitBtn = document.getElementById('hpBidModalSubmitBtn');
    var bidAlert = document.getElementById('hpBidModalAlert');
    var bidLoginPrompt = document.getElementById('hpBidModalLoginPrompt');

    function showBidAlert(msg, type) {
      if (!bidAlert) return;
      bidAlert.className = 'hp-bid-alert hp-bid-alert--' + (type || 'error');
      bidAlert.innerHTML = msg;
      bidAlert.style.display = 'block';
    }

    function hideBidAlert() {
      if (bidAlert) bidAlert.style.display = 'none';
    }

    function openBidModal(card) {
      if (!bidModal || !card) return;
      activeCard = card;

      hideBidAlert();

      var title = card.dataset.productTitle || 'Product Auction';
      var sku = card.dataset.productSku || '';
      var img = card.dataset.productImg || '';
      var currentBid = card.dataset.currentBidVal || card.dataset.startBidVal || '0';
      var minBid = card.dataset.minBidVal || currentBid;

      var modalTitle = document.getElementById('hpBidModalProdTitle');
      var modalSku = document.getElementById('hpBidModalProdSku');
      var modalImg = document.getElementById('hpBidModalProdImg');
      var modalCurrent = document.getElementById('hpBidModalCurrentBid');
      var modalMin = document.getElementById('hpBidModalMinBid');
      var modalMinHint = document.getElementById('hpBidModalMinBidHint');

      if (modalTitle) modalTitle.textContent = title;
      if (modalSku) modalSku.textContent = 'SKU ' + sku;
      if (modalImg) {
        if (img) {
          modalImg.src = img;
          modalImg.style.display = 'block';
        } else {
          modalImg.style.display = 'none';
        }
      }
      if (modalCurrent) modalCurrent.textContent = formatRupiah(currentBid);
      if (modalMin) modalMin.textContent = formatRupiah(minBid);
      if (modalMinHint) modalMinHint.textContent = 'Min. allowed: ' + formatRupiah(minBid);

      // Pre-fill input with minimum required bid
      if (bidInput) {
        var minBidDigits = cleanDigits(minBid);
        bidInput.value = formatNumberDigits(minBidDigits);
      }

      // Check login state
      if (!isLoggedIn) {
        if (bidSubmitBtn) {
          bidSubmitBtn.style.setProperty('display', 'flex', 'important');
          bidSubmitBtn.disabled = true;
          bidSubmitBtn.classList.add('is-disabled');
          var textSpan = bidSubmitBtn.querySelector('.hp-bid-submit-btn__text');
          if (textSpan) textSpan.textContent = 'Place My Bid';
        }
        if (bidInput) {
          bidInput.disabled = true;
        }
        if (bidLoginPrompt) {
          bidLoginPrompt.style.setProperty('display', 'block', 'important');
        }
      } else {
        if (bidSubmitBtn) {
          bidSubmitBtn.style.setProperty('display', 'flex', 'important');
          bidSubmitBtn.disabled = false;
          bidSubmitBtn.classList.remove('is-disabled');
          var spinner = bidSubmitBtn.querySelector('.hp-bid-submit-btn__spinner');
          if (spinner) spinner.style.display = 'none';
          var textSpan = bidSubmitBtn.querySelector('.hp-bid-submit-btn__text');
          if (textSpan) textSpan.textContent = 'Place My Bid';
        }
        if (bidInput) {
          bidInput.disabled = false;
        }
        if (bidLoginPrompt) {
          bidLoginPrompt.style.setProperty('display', 'none', 'important');
        }
      }

      bidModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (isLoggedIn && bidInput) {
        setTimeout(function () { bidInput.focus(); }, 150);
      }
    }

    function closeBidModal() {
      if (!bidModal) return;
      bidModal.classList.remove('is-open');
      document.body.style.overflow = '';
      activeCard = null;
    }

    function openHistoryModal(card) {
      if (!historyModal || !card) return;
      var title = card.dataset.productTitle || 'Product Auction';
      var sku = card.dataset.productSku || '';
      var auctionId = card.dataset.auctionId;

      var modalTitle = document.getElementById('hpHistoryModalProdTitle');
      if (modalTitle) modalTitle.textContent = title + (sku ? ' (SKU ' + sku + ')' : '');

      var loadingEl = document.getElementById('hpHistoryModalLoading');
      var contentEl = document.getElementById('hpHistoryModalContent');

      if (loadingEl) {
        loadingEl.style.setProperty('display', 'flex', 'important');
        loadingEl.classList.remove('is-hidden');
      }
      if (contentEl) {
        contentEl.style.setProperty('display', 'none', 'important');
        contentEl.innerHTML = '';
      }

      historyModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // Check if already cached
      if (card._biddersHtml) {
        renderHistoryContent(card._biddersHtml);
        return;
      }

      if (!auctionId) {
        if (loadingEl) {
          loadingEl.style.setProperty('display', 'none', 'important');
          loadingEl.classList.add('is-hidden');
        }
        if (contentEl) {
          contentEl.style.setProperty('display', 'block', 'important');
          contentEl.innerHTML = '<div class="hp-history-empty"><p>No auction history available yet.</p></div>';
        }
        return;
      }

      var bidsUrl = 'https://sp-auction.webkul.com/index.php?p=wk_ajax_process&shop_name=' +
        encodeURIComponent(shopName) + '&auction_id=' + encodeURIComponent(auctionId) + '&callback=show_bids';

      queueJsonp(bidsUrl, 'show_bids', function (err, res) {
        if (err || !res) {
          if (loadingEl) {
            loadingEl.style.setProperty('display', 'none', 'important');
            loadingEl.classList.add('is-hidden');
          }
          if (contentEl) {
            contentEl.style.setProperty('display', 'block', 'important');
            contentEl.innerHTML = '<div class="hp-history-empty"><p>Unable to load bidding history. Please try again.</p></div>';
          }
          return;
        }

        if (res.bidders) {
          card._biddersHtml = res.bidders;
          renderHistoryContent(res.bidders);
        } else {
          if (loadingEl) {
            loadingEl.style.setProperty('display', 'none', 'important');
            loadingEl.classList.add('is-hidden');
          }
          if (contentEl) {
            contentEl.style.setProperty('display', 'block', 'important');
            contentEl.innerHTML = '<div class="hp-history-empty"><p>No bids have been placed yet for this item.</p></div>';
          }
        }
      });
    }

    function renderHistoryContent(biddersHtml) {
      var loadingEl = document.getElementById('hpHistoryModalLoading');
      var contentEl = document.getElementById('hpHistoryModalContent');
      if (loadingEl) {
        loadingEl.style.setProperty('display', 'none', 'important');
        loadingEl.classList.add('is-hidden');
      }
      if (!contentEl) return;

      contentEl.style.setProperty('display', 'block', 'important');

      contentEl.style.display = 'block';

      // Extract rows from Webkul HTML table
      var parser = new DOMParser();
      var doc = parser.parseFromString(biddersHtml, 'text/html');
      var rows = doc.querySelectorAll('table tbody tr:not(.td_pagination)');

      if (rows.length === 0) {
        contentEl.innerHTML = '<div class="hp-history-empty"><p>No bids have been placed yet for this item. Be the first to bid!</p></div>';
        return;
      }

      var html = '<div class="hp-history-table-wrap"><table class="hp-history-table"><thead><tr>';
      html += '<th>Bidder Name</th><th>Bid Amount</th><th>Bidding Date</th></tr></thead><tbody>';

      var validRows = 0;
      rows.forEach(function (tr, index) {
        var tds = tr.querySelectorAll('td');
        if (tds.length >= 2) {
          validRows++;
          var bidder = tds[0].textContent.trim() || 'Anonymous';
          var amountText = tds[1].textContent.trim();
          var date = (tds[2] ? tds[2].textContent.trim() : '') || '-';

          // Format amount cleanly
          var formattedAmount = formatRupiah(amountText);

          html += '<tr class="' + (index === 0 ? 'hp-highest-bid-row' : '') + '">';
          html += '<td class="hp-bidder-name">' + bidder + (index === 0 ? ' <span class="hp-lead-badge">Leading</span>' : '') + '</td>';
          html += '<td class="hp-bidder-amount">' + formattedAmount + '</td>';
          html += '<td class="hp-bidder-date">' + date + '</td>';
          html += '</tr>';
        }
      });

      html += '</tbody></table></div>';

      if (validRows === 0) {
        contentEl.innerHTML = '<div class="hp-history-empty"><p>No bids have been placed yet for this item.</p></div>';
      } else {
        contentEl.innerHTML = html;
      }
    }

    function closeHistoryModal() {
      if (!historyModal) return;
      historyModal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Setup Modal Close Handlers
    var bidModalClose = document.getElementById('hpBidModalClose');
    var bidModalBackdrop = document.getElementById('hpBidModalBackdrop');
    if (bidModalClose) bidModalClose.addEventListener('click', closeBidModal);
    if (bidModalBackdrop) bidModalBackdrop.addEventListener('click', closeBidModal);

    var historyModalClose = document.getElementById('hpHistoryModalClose');
    var historyModalBackdrop = document.getElementById('hpHistoryModalBackdrop');
    if (historyModalClose) historyModalClose.addEventListener('click', closeHistoryModal);
    if (historyModalBackdrop) historyModalBackdrop.addEventListener('click', closeHistoryModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (bidModal && bidModal.classList.contains('is-open')) closeBidModal();
        if (historyModal && historyModal.classList.contains('is-open')) closeHistoryModal();
      }
    });

    // Bid Input Live Formatting
    if (bidInput) {
      bidInput.addEventListener('input', function () {
        hideBidAlert();
        var raw = cleanDigits(bidInput.value);
        bidInput.value = formatNumberDigits(raw);
      });
    }

    // Quick Increment Buttons in Modal
    var pillBtns = document.querySelectorAll('.hp-bid-pill-btn');
    pillBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!activeCard || !bidInput) return;
        hideBidAlert();
        var incType = btn.dataset.increment;
        var minBid = parseFloat(cleanDigits(activeCard.dataset.minBidVal || '0')) || 0;
        var currentInputVal = parseFloat(cleanDigits(bidInput.value || '0')) || 0;

        if (incType === 'min') {
          bidInput.value = formatNumberDigits(minBid);
        } else {
          var incNum = parseFloat(incType) || 0;
          var base = currentInputVal > 0 ? currentInputVal : minBid;
          var nextVal = base + incNum;
          if (nextVal < minBid) nextVal = minBid;
          bidInput.value = formatNumberDigits(nextVal);
        }
      });
    });

    // Submit Bid inside Modal
    if (bidSubmitBtn) {
      bidSubmitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!activeCard) return;

        if (!isLoggedIn) {
          showBidAlert('You must be signed in to submit a bid. Please <a href="/account/login?checkout_url=' + encodeURIComponent(window.location.pathname) + '" style="text-decoration:underline;font-weight:700;color:inherit;">Log In here &rarr;</a>', 'error');
          if (bidLoginPrompt) bidLoginPrompt.style.setProperty('display', 'block', 'important');
          return;
        }

        var rawDigits = cleanDigits(bidInput ? bidInput.value : '');
        var bidAmount = parseFloat(rawDigits) || 0;
        var minBid = parseFloat(cleanDigits(activeCard.dataset.minBidVal || '0')) || 0;

        if (bidAmount <= 0) {
          showBidAlert('Please enter a valid bid amount.', 'error');
          if (bidInput) bidInput.focus();
          return;
        }

        if (bidAmount < minBid) {
          showBidAlert('Bid amount must be at least ' + formatRupiah(minBid) + '.', 'error');
          if (bidInput) bidInput.focus();
          return;
        }

        var auctionId = activeCard.dataset.auctionId;
        if (!auctionId) {
          showBidAlert('Auction information not ready. Please try again in a moment.', 'error');
          return;
        }

        var isPrivateChk = document.getElementById('hpBidModalPrivateChk');
        var isPrivate = isPrivateChk && isPrivateChk.checked ? 1 : 0;

        // Button loading state
        bidSubmitBtn.disabled = true;
        var spinner = bidSubmitBtn.querySelector('.hp-bid-submit-btn__spinner');
        if (spinner) spinner.style.display = 'inline-block';
        var textSpan = bidSubmitBtn.querySelector('.hp-bid-submit-btn__text');
        if (textSpan) textSpan.textContent = 'Placing Bid...';

        var persistUrl = 'https://sp-auction.webkul.com/index.php?p=wk_ajax_process' +
          '&shop_name=' + encodeURIComponent(shopName) +
          '&cust_id=' + encodeURIComponent(customerId) +
          '&auction_id=' + encodeURIComponent(auctionId) +
          '&bid_amount=' + encodeURIComponent(bidAmount) +
          '&is_public=' + (isPrivate ? '0' : '1') +
          '&product_page=true' +
          '&checkout_url=' + encodeURIComponent(window.location.href) +
          '&callback=persistbid';

        queueJsonp(persistUrl, 'persistbid', function (err, res) {
          bidSubmitBtn.disabled = false;
          if (spinner) spinner.style.display = 'none';
          if (textSpan) textSpan.textContent = 'Place My Bid';

          if (err || !res) {
            showBidAlert('Network error while placing bid. Please try again.', 'error');
            return;
          }

          if (res.msg === 'success') {
            showBidAlert('🎉 Success! Your bid of ' + formatRupiah(bidAmount) + ' has been placed.', 'success');

            // Update card directly
            var priceValEl = activeCard.querySelector('.hp-auction-price-val');
            if (priceValEl) priceValEl.textContent = formatRupiah(bidAmount);
            activeCard.dataset.currentBidVal = String(bidAmount);

            var currentBidsCount = parseInt(activeCard.dataset.bidCountVal || '0', 10) + 1;
            activeCard.dataset.bidCountVal = String(currentBidsCount);
            var bidCountValEl = activeCard.querySelector('.hp-auction-bidcount-val');
            if (bidCountValEl) bidCountValEl.textContent = currentBidsCount + ' bids';

            // Clear cache so history reloads next time
            delete activeCard._biddersHtml;

            // Update min bid if provided
            if (res.min_bid_amount) {
              activeCard.dataset.minBidVal = cleanDigits(res.min_bid_amount);
            }

            setTimeout(function () {
              closeBidModal();
            }, 1800);
          } else if (res.msg === 'invalid_bid' || res.msg === 'invalid_bid_type') {
            var newMin = res.min_bid_amount ? formatRupiah(res.min_bid_amount) : formatRupiah(minBid);
            showBidAlert('Bid too low. Minimum allowed bidding amount is ' + newMin + '.', 'error');
            if (res.min_bid_amount) {
              activeCard.dataset.minBidVal = cleanDigits(res.min_bid_amount);
              var modalMin = document.getElementById('hpBidModalMinBid');
              if (modalMin) modalMin.textContent = newMin;
            }
          } else if (res.msg === 'restrict_to_bid_again') {
            showBidAlert("You can't place consecutive bids. Please wait for another bidder to bid.", 'error');
          } else if (res.msg === 'user_is_banned') {
            showBidAlert('Your account is restricted from placing bids on this store.', 'error');
          } else {
            showBidAlert(res.msg || 'Unable to place bid. Please verify and try again.', 'error');
          }
        });
      });
    }

    // Process all cards on the page with loading skeleton
    var cards = auctionPage.querySelectorAll('.hp-auction-card');
    var totalCardsToProcess = cards.length;
    var processedCardsCount = 0;
    var isClassificationComplete = false;
    var skeletonEl = document.getElementById('hpAuctionSkeleton');
    var cardsListEl = document.getElementById('hp-auction-products');

    function checkClassificationCompletion() {
      processedCardsCount++;
      if (processedCardsCount >= totalCardsToProcess && !isClassificationComplete) {
        finishClassification();
      }
    }

    function finishClassification() {
      if (isClassificationComplete) return;
      isClassificationComplete = true;

      if (classificationTimeout) {
        window.clearTimeout(classificationTimeout);
        classificationTimeout = null;
      }

      // Smoothly hide skeleton and reveal the classified card list
      if (skeletonEl) {
        skeletonEl.classList.add('is-hidden');
        skeletonEl.style.setProperty('display', 'none', 'important');
      }
      if (cardsListEl) {
        cardsListEl.style.setProperty('display', 'flex', 'important');
        // Trigger CSS fade in
        window.requestAnimationFrame(function () {
          cardsListEl.style.opacity = '1';
        });
      }

      updateTabFiltering();
    }

    // Safety timeout: reveal cards after 6 seconds even if Webkul has slow requests
    var classificationTimeout = window.setTimeout(function () {
      finishClassification();
    }, 6000);

    var totalToolbar = document.getElementById('hp-auction-total');
    if (totalToolbar) {
      totalToolbar.textContent = 'CHECKING...';
    }

    cards.forEach(function (card) {
      var prodId = card.dataset.productId;
      var prodHandle = card.dataset.productHandle;
      if (!prodId || !prodHandle) {
        checkClassificationCompletion();
        return;
      }

      var ajaxUrl = 'https://sp-auction.webkul.com/index.php?p=wk_ajax_process&shop_name=' +
        encodeURIComponent(shopName) + '&prod_id=' + encodeURIComponent(prodId) +
        '&page=' + encodeURIComponent(prodHandle) + '&callback=biddingform';

      queueJsonp(ajaxUrl, 'biddingform', function (err, html) {
        if (err || !html || html === 'unavailable') {
          // No live auction configured yet for this product -> Coming Soon
          card.dataset.status = 'coming-soon';
          var badgeEl = card.querySelector('.hp-auction-badge');
          if (badgeEl) {
            badgeEl.textContent = 'COMING SOON';
            badgeEl.className = 'hp-auction-badge hp-auction-badge--upcoming';
          }

          var labelEl = card.querySelector('.hp-auction-label');
          if (labelEl) labelEl.textContent = 'Starting bid';

          // User request: mask coming soon price dynamically based on base price
          var priceValEl = card.querySelector('.hp-auction-price-val');
          if (priceValEl) priceValEl.textContent = maskPriceDynamic(card.dataset.productPrice, card.dataset.productPriceFormatted);

          var startingBidRow = card.querySelector('.hp-auction-starting');
          if (startingBidRow) startingBidRow.style.display = 'none';

          var timerLabel = card.querySelector('.hp-auction-timer-label');
          if (timerLabel) timerLabel.textContent = 'Starts in';

          var clockEl = card.querySelector('.hp-auction-clock');
          // Start countdown timer: check card data-start-time or default
          var startTargetMs = parseDateToMs(card.dataset.startTime) ||
                              parseDateToMs(auctionPage.dataset.defaultStartTime);

          if (startTargetMs > 0) {
            card.dataset.startTimeMs = String(startTargetMs);
          } else if (clockEl) {
            clockEl.textContent = 'Coming Soon';
          }

          // Show View Product button
          var bidBtn = card.querySelector('.hp-auction-btn-bid');
          var viewBtn = card.querySelector('.hp-auction-btn-view');
          if (bidBtn) bidBtn.style.display = 'none';
          if (viewBtn) viewBtn.style.display = 'flex';
          checkClassificationCompletion();
          return;
        }

        // Parse Webkul response
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var hasBiddingForm = doc.querySelector('#bidding-form') !== null;
        var finishedMsgEl = doc.querySelector('.pa-finished-msg:not(.pa-hide)');
        var hasClosedText = (html.indexOf('Bidding closed for this product') !== -1 && html.indexOf('pa-hide pa-finished-msg') === -1);
        var isEnded = (hasBiddingForm && (finishedMsgEl !== null || hasClosedText)) ||
                      (!hasBiddingForm && (finishedMsgEl !== null || hasClosedText || doc.querySelector('.auction_ended_at') !== null));

        var isUpcoming = !isEnded && (!hasBiddingForm ||
                         html.indexOf('Auction will start') !== -1 ||
                         html.indexOf('Auction has not started') !== -1 ||
                         /var\s+time_left_to_start\s*=\s*[1-9]/.test(html));

        var auctionIdInput = doc.querySelector('input[name="auction_id"], #auction_id');
        var auctionId = auctionIdInput ? auctionIdInput.value : '';
        card.dataset.auctionId = auctionId;

        // Start bid
        var startBidEl = doc.querySelector('#start_bid .pa-text-color') || doc.querySelector('.start_price_after_finish') || doc.querySelector('#start_bid');
        var startBidText = startBidEl ? startBidEl.textContent.trim() : '';
        var startBidDigits = cleanDigits(startBidText);
        card.dataset.startBidVal = startBidDigits;

        var startBidTarget = card.querySelector('.hp-auction-starting-val');
        if (startBidTarget && startBidDigits) {
          startBidTarget.textContent = formatRupiah(startBidDigits);
        }

        // Bid Count
        var showBidsEl = doc.querySelector('#show_bids');
        var bidCount = 0;
        if (showBidsEl) {
          var label = showBidsEl.dataset.bidsLabel || showBidsEl.textContent;
          var match = label.match(/(\d+)/);
          if (match) bidCount = parseInt(match[1], 10);
        }
        card.dataset.bidCountVal = String(bidCount);
        var bidCountTarget = card.querySelector('.hp-auction-bidcount-val');
        if (bidCountTarget) {
          bidCountTarget.textContent = bidCount + (bidCount === 1 ? ' bid' : ' bids');
        }

        // Min Bid Amount
        var minBid = 0;
        var minBidMatch = html.match(/var\s+min_bid_amount\s*=\s*(\d+);/);
        if (minBidMatch) {
          minBid = parseInt(minBidMatch[1], 10);
        } else {
          var minBidEl = doc.querySelector('.min_bid_amt');
          if (minBidEl) minBid = parseFloat(cleanDigits(minBidEl.textContent)) || 0;
        }
        card.dataset.minBidVal = String(minBid);

        var badgeEl = card.querySelector('.hp-auction-badge');
        var labelEl = card.querySelector('.hp-auction-label');
        var priceValEl = card.querySelector('.hp-auction-price-val');
        var timerEl = card.querySelector('.hp-auction-timer');
        var timerLabelEl = card.querySelector('.hp-auction-timer-label');
        var clockEl = card.querySelector('.hp-auction-clock');
        var bidBtn = card.querySelector('.hp-auction-btn-bid');
        var viewBtn = card.querySelector('.hp-auction-btn-view');
        var startingBidRow = card.querySelector('.hp-auction-starting');

        if (isEnded) {
          // --- ENDED STATE ---
          card.dataset.status = 'ended';

          // Extract final ended price
          var endedAtEl = doc.querySelector('.auction_ended_at');
          var endedPriceDigits = endedAtEl ? cleanDigits(endedAtEl.textContent) : startBidDigits;
          card.dataset.currentBidVal = endedPriceDigits;

          if (badgeEl) {
            badgeEl.textContent = 'AUCTION ENDED';
            badgeEl.className = 'hp-auction-badge hp-auction-badge--ended';
          }
          if (labelEl) labelEl.textContent = 'Final bid';
          if (priceValEl && endedPriceDigits) priceValEl.textContent = formatRupiah(endedPriceDigits);
          if (startingBidRow) startingBidRow.style.display = '';
          if (timerLabelEl) timerLabelEl.textContent = 'Auction status';
          if (clockEl) clockEl.textContent = 'Ended';

          // Button changes to "View Product"
          if (bidBtn) bidBtn.style.display = 'none';
          if (viewBtn) viewBtn.style.display = 'flex';
          if (isClassificationComplete) updateTabFiltering();
          checkClassificationCompletion();
        } else if (isUpcoming) {
          // --- COMING SOON STATE ---
          card.dataset.status = 'coming-soon';
          if (badgeEl) {
            badgeEl.textContent = 'COMING SOON';
            badgeEl.className = 'hp-auction-badge hp-auction-badge--upcoming';
          }
          if (labelEl) labelEl.textContent = 'Starting bid';

          // User request: mask coming soon price dynamically based on base price
          if (priceValEl) priceValEl.textContent = maskPriceDynamic(card.dataset.productPrice, card.dataset.productPriceFormatted);
          if (startingBidRow) startingBidRow.style.display = 'none';

          if (timerLabelEl) timerLabelEl.textContent = 'Starts in';

          // Parse start date from Webkul response if available
          var targetStartMs = 0;
          var startDateEl = doc.querySelector('.td_start_date');
          if (startDateEl && startDateEl.textContent.trim()) {
            targetStartMs = parseDateToMs(startDateEl.textContent.trim());
          }

          if (!targetStartMs) {
            var startMatch = html.match(/var\s+time_left_to_start\s*=\s*(\d+);/);
            if (startMatch) {
              var rawStart = parseInt(startMatch[1], 10);
              if (rawStart > 1000000000) {
                targetStartMs = rawStart * 1000;
              } else if (rawStart > 0) {
                targetStartMs = Date.now() + (rawStart * 1000);
              }
            }
          }

          if (!targetStartMs) {
            targetStartMs = parseDateToMs(card.dataset.startTime) ||
                            parseDateToMs(auctionPage.dataset.defaultStartTime);
          }

          if (targetStartMs > 0) {
            card.dataset.startTimeMs = String(targetStartMs);
          } else if (clockEl) {
            clockEl.textContent = 'Coming Soon';
          }

          if (bidBtn) bidBtn.style.display = 'none';
          if (viewBtn) viewBtn.style.display = 'flex';
          if (isClassificationComplete) updateTabFiltering();
          checkClassificationCompletion();
        } else {
          // --- ACTIVE STATE ---
          card.dataset.status = 'active';

          if (badgeEl) {
            badgeEl.textContent = 'LIVE AUCTION';
            badgeEl.className = 'hp-auction-badge';
          }
          if (labelEl) labelEl.textContent = 'Current bid';
          if (startingBidRow) startingBidRow.style.display = '';

          // Button is "Place My Bid"
          if (bidBtn) bidBtn.style.display = 'flex';
          if (viewBtn) viewBtn.style.display = 'none';
          if (isClassificationComplete) updateTabFiltering();
          checkClassificationCompletion();

          // Time remaining countdown (parses Webkul end date or absolute Unix timestamp)
          var targetEndMs = 0;
          var endDateEl = doc.querySelector('.td_end_date');
          if (endDateEl && endDateEl.textContent.trim()) {
            var rawDateStr = endDateEl.textContent.trim();
            // Webkul format: YYYY-MM-DD HH:mm:ss in GMT+7 (Western Indonesia Time)
            var isoStr = rawDateStr.replace(' ', 'T') + '+07:00';
            var parsedMs = Date.parse(isoStr);
            if (!isNaN(parsedMs) && parsedMs > 0) {
              targetEndMs = parsedMs;
            }
          }

          if (!targetEndMs) {
            var timeMatch = html.match(/var\s+time_left_to_end\s*=\s*(\d+);/);
            if (timeMatch) {
              var rawTime = parseInt(timeMatch[1], 10);
              if (rawTime > 1000000000) {
                // Absolute Unix timestamp in seconds
                targetEndMs = rawTime * 1000;
              } else if (rawTime > 0) {
                // Relative seconds remaining
                targetEndMs = Date.now() + (rawTime * 1000);
              }
            }
          }

          if (targetEndMs > 0) {
            card.dataset.endTime = String(targetEndMs);
          }

          // Fetch the latest bid price if there are bids
          if (bidCount > 0 && auctionId) {
            var bidsUrl = 'https://sp-auction.webkul.com/index.php?p=wk_ajax_process&shop_name=' +
              encodeURIComponent(shopName) + '&auction_id=' + encodeURIComponent(auctionId) + '&callback=show_bids';

            queueJsonp(bidsUrl, 'show_bids', function (bErr, bRes) {
              if (!bErr && bRes && bRes.bidders) {
                card._biddersHtml = bRes.bidders;
                var bDoc = parser.parseFromString(bRes.bidders, 'text/html');
                var topRow = bDoc.querySelector('table tbody tr:not(.td_pagination)');
                if (topRow) {
                  var tds = topRow.querySelectorAll('td');
                  if (tds.length >= 2) {
                    var highestBidDigits = cleanDigits(tds[1].textContent);
                    if (highestBidDigits) {
                      card.dataset.currentBidVal = highestBidDigits;
                      if (priceValEl) priceValEl.textContent = formatRupiah(highestBidDigits);
                    }
                  }
                }
                if (bRes.min_bid_amount) {
                  card.dataset.minBidVal = cleanDigits(bRes.min_bid_amount);
                }
              }
            });
          } else {
            // No bids yet: current bid starts at start bid
            card.dataset.currentBidVal = startBidDigits;
            if (priceValEl && startBidDigits) {
              priceValEl.textContent = formatRupiah(startBidDigits);
            }
          }
        }
      });
    });

    // Delegated click listener for Card Actions
    auctionPage.addEventListener('click', function (e) {
      var bidTrigger = e.target.closest('[data-action="open-bid-modal"]');
      if (bidTrigger) {
        e.preventDefault();
        var card = bidTrigger.closest('.hp-auction-card');
        if (card && card.dataset.status === 'active') {
          openBidModal(card);
        }
        return;
      }

      var checkBidsTrigger = e.target.closest('[data-action="check-bids"]');
      if (checkBidsTrigger) {
        e.preventDefault();
        var cardForBids = checkBidsTrigger.closest('.hp-auction-card');
        if (cardForBids) {
          openHistoryModal(cardForBids);
        }
        return;
      }
    });

    // Global Live Countdown Timer for active and coming-soon cards
    function updateCollectionTimers() {
      // 1. Active auctions: count down to end time
      var activeCards = auctionPage.querySelectorAll('.hp-auction-card[data-status="active"]');
      activeCards.forEach(function (card) {
        var endTimestamp = parseInt(card.dataset.endTime, 10);
        var clock = card.querySelector('.hp-auction-clock');
        if (!clock || !endTimestamp) return;

        var remaining = Math.max(0, Math.floor((endTimestamp - Date.now()) / 1000));
        if (remaining <= 0) {
          clock.textContent = 'Ended';
          card.dataset.status = 'ended';
          var badgeEl = card.querySelector('.hp-auction-badge');
          if (badgeEl) {
            badgeEl.textContent = 'AUCTION ENDED';
            badgeEl.className = 'hp-auction-badge hp-auction-badge--ended';
          }
          var bidBtn = card.querySelector('.hp-auction-btn-bid');
          var viewBtn = card.querySelector('.hp-auction-btn-view');
          if (bidBtn) bidBtn.style.display = 'none';
          if (viewBtn) viewBtn.style.display = 'flex';
          updateTabFiltering();
          return;
        }

        var days = Math.floor(remaining / 86400);
        var hours = Math.floor((remaining % 86400) / 3600);
        var minutes = Math.floor((remaining % 3600) / 60);
        var seconds = remaining % 60;

        function pad(n) { return String(n).padStart(2, '0'); }

        clock.textContent = (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      });

      // 2. Coming Soon auctions: count down to start time
      var upcomingCards = auctionPage.querySelectorAll('.hp-auction-card[data-status="coming-soon"]');
      upcomingCards.forEach(function (card) {
        var clock = card.querySelector('.hp-auction-clock');
        if (!clock) return;

        var startTimestamp = parseInt(card.dataset.startTimeMs, 10);
        if (!startTimestamp || isNaN(startTimestamp)) {
          // If no specific start date configured, display Coming Soon
          if (clock.textContent !== 'Coming Soon') clock.textContent = 'Coming Soon';
          return;
        }

        var remainingStart = Math.max(0, Math.floor((startTimestamp - Date.now()) / 1000));
        if (remainingStart <= 0) {
          clock.textContent = 'Starting Now';
          return;
        }

        var days = Math.floor(remainingStart / 86400);
        var hours = Math.floor((remainingStart % 86400) / 3600);
        var minutes = Math.floor((remainingStart % 3600) / 60);
        var seconds = remainingStart % 60;

        function pad(n) { return String(n).padStart(2, '0'); }

        clock.textContent = (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      });
    }

    window.setInterval(updateCollectionTimers, 1000);
    updateCollectionTimers();

    // =========================================================================
    // Tabs & Client-Side Pagination Controller
    // =========================================================================
    var currentTab = 'active';
    var currentPage = 1;
    var pageSize = 50; // 50 products per page

    function renderPaginationControls(totalPages, totalItems) {
      var paginationEl = document.getElementById('hpAuctionPagination');
      if (!paginationEl) return;

      if (!isClassificationComplete || totalPages <= 1) {
        paginationEl.innerHTML = '';
        paginationEl.style.setProperty('display', 'none', 'important');
        return;
      }

      var html = '<div class="hp-pagination-wrapper">';

      // Prev Button
      var prevDisabled = currentPage === 1 ? ' disabled aria-disabled="true"' : '';
      html += '<button type="button" class="hp-pagination-btn hp-pagination-btn--prev"' + prevDisabled + ' data-page="' + (currentPage - 1) + '" aria-label="Previous Page">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>';
      html += '<span>Prev</span>';
      html += '</button>';

      // Page Number Buttons
      html += '<div class="hp-pagination-pages">';
      for (var p = 1; p <= totalPages; p++) {
        var isActive = p === currentPage;
        html += '<button type="button" class="hp-pagination-page-btn' + (isActive ? ' is-active' : '') + '"' +
                (isActive ? ' aria-current="page"' : '') + ' data-page="' + p + '">' + p + '</button>';
      }
      html += '</div>';

      // Next Button
      var nextDisabled = currentPage === totalPages ? ' disabled aria-disabled="true"' : '';
      html += '<button type="button" class="hp-pagination-btn hp-pagination-btn--next"' + nextDisabled + ' data-page="' + (currentPage + 1) + '" aria-label="Next Page">';
      html += '<span>Next</span>';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>';
      html += '</button>';

      html += '</div>';

      paginationEl.innerHTML = html;
      paginationEl.style.setProperty('display', 'flex', 'important');

      // Bind pagination clicks
      var pageButtons = paginationEl.querySelectorAll('button[data-page]');
      pageButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled || b.getAttribute('aria-disabled') === 'true') return;
          var targetPage = parseInt(b.dataset.page, 10);
          if (isNaN(targetPage) || targetPage < 1 || targetPage > totalPages || targetPage === currentPage) return;
          currentPage = targetPage;
          updateTabFiltering();

          // Smooth scroll to top of auction tabs
          var tabsNav = auctionPage.querySelector('.hp-auction-tabs-nav');
          if (tabsNav) {
            tabsNav.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    function updateTabFiltering() {
      var allCards = auctionPage.querySelectorAll('.hp-auction-card');
      var activeCount = 0;
      var comingSoonCount = 0;
      var endedCount = 0;

      // Classify counts across all cards
      allCards.forEach(function (c) {
        var st = c.dataset.status;
        if (st === 'active') {
          activeCount++;
        } else if (st === 'ended') {
          endedCount++;
        } else if (st === 'coming-soon' || st === 'unavailable') {
          comingSoonCount++;
        } else if (st === 'loading') {
          activeCount++;
        }
      });

      // Update Tab Badges
      var activeBadge = document.getElementById('hpTabCountActive');
      var comingSoonBadge = document.getElementById('hpTabCountComingSoon');
      var endedBadge = document.getElementById('hpTabCountEnded');

      if (!isClassificationComplete) {
        if (activeBadge) activeBadge.classList.add('is-loading');
        if (comingSoonBadge) comingSoonBadge.classList.add('is-loading');
        if (endedBadge) endedBadge.classList.add('is-loading');
      } else {
        if (activeBadge) {
          activeBadge.classList.remove('is-loading');
          activeBadge.textContent = String(activeCount);
        }
        if (comingSoonBadge) {
          comingSoonBadge.classList.remove('is-loading');
          comingSoonBadge.textContent = String(comingSoonCount);
        }
        if (endedBadge) {
          endedBadge.classList.remove('is-loading');
          endedBadge.textContent = String(endedCount);
        }
      }

      // Collect cards matching currentTab
      var matchedCards = [];
      allCards.forEach(function (c) {
        var st = c.dataset.status;
        var matches = false;

        if (currentTab === 'active') {
          matches = (st === 'active' || st === 'loading');
        } else if (currentTab === 'coming-soon') {
          matches = (st === 'coming-soon' || st === 'unavailable');
        } else if (currentTab === 'ended') {
          matches = (st === 'ended');
        }

        if (matches) {
          matchedCards.push(c);
        } else {
          c.style.setProperty('display', 'none', 'important');
        }
      });

      var totalInTab = matchedCards.length;
      var totalPages = Math.max(1, Math.ceil(totalInTab / pageSize));

      if (currentPage > totalPages) {
        currentPage = totalPages;
      }

      var startIndex = (currentPage - 1) * pageSize;
      var endIndex = startIndex + pageSize;

      // Slice visible cards for current page
      matchedCards.forEach(function (c, idx) {
        if (idx >= startIndex && idx < endIndex) {
          c.style.setProperty('display', '', '');
        } else {
          c.style.setProperty('display', 'none', 'important');
        }
      });

      // Update toolbar count
      var totalSpan = document.getElementById('hp-auction-total');
      if (totalSpan) {
        if (!isClassificationComplete) {
          totalSpan.textContent = 'CHECKING...';
        } else {
          var labelWord = totalInTab === 1 ? ' AUCTION' : ' AUCTIONS';
          if (totalPages > 1) {
            totalSpan.textContent = totalInTab + labelWord + ' (PAGE ' + currentPage + '/' + totalPages + ')';
          } else {
            totalSpan.textContent = totalInTab + labelWord;
          }
        }
      }

      // Render pagination controls
      renderPaginationControls(totalPages, totalInTab);

      // Empty State Display
      var emptyEl = document.getElementById('hpAuctionTabEmpty');
      if (emptyEl) {
        if (!isClassificationComplete) {
          emptyEl.style.setProperty('display', 'none', 'important');
        } else if (totalInTab === 0) {
          emptyEl.style.setProperty('display', 'flex', 'important');
          var titleEl = emptyEl.querySelector('.hp-auction-tab-empty__title');
          var descEl = emptyEl.querySelector('.hp-auction-tab-empty__desc');
          if (currentTab === 'active') {
            if (titleEl) titleEl.textContent = 'No Active Auctions';
            if (descEl) descEl.textContent = 'There are no active auctions running right now. Please explore our coming soon auctions or check back later!';
          } else if (currentTab === 'coming-soon') {
            if (titleEl) titleEl.textContent = 'No Coming Soon Auctions';
            if (descEl) descEl.textContent = 'There are no upcoming auctions scheduled at the moment.';
          } else if (currentTab === 'ended') {
            if (titleEl) titleEl.textContent = 'No Ended Auctions';
            if (descEl) descEl.textContent = 'There are no completed auctions to display.';
          }
        } else {
          emptyEl.style.setProperty('display', 'none', 'important');
        }
      }
    }

    // Attach Tab Click Listeners
    var tabBtns = auctionPage.querySelectorAll('.hp-auction-tab-btn');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tabKey = btn.dataset.tab;
        if (!tabKey || tabKey === currentTab) return;
        currentTab = tabKey;
        currentPage = 1; // reset page to 1 when switching tabs

        tabBtns.forEach(function (b) {
          var isActive = (b === btn);
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        updateTabFiltering();
      });
    });

    // Run initial filtering pass
    updateTabFiltering();
  }

  function initAll() {
    initAuctionPortalEnhancements();
    initAuctionCollectionPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();


